module.exports = __webpack_public_path__ + "img/IMG-20180802-WA0012.c35c073e.jpg";